import CartComp from "./Components/CartComp";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <h1>CART COMPONENTS</h1>
      <CartComp />
    </div>
  );
}
